exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "input[data-v-0ea62850]{border:1px solid #ddd;border-radius:4px;padding:12px;width:100%}", ""]);

// exports
